// extracted by mini-css-extract-plugin
export default {"root":"_3m6Up","text-block":"_32XMj","textBlock":"_32XMj","prefix":"_1cMI9"};